import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { OnboardingState } from '../config/state.model';
import { AuthService } from './auth.service';
import { buildRowPayload } from './payload-builder';

@Injectable({ providedIn: 'root' })
export class TbmSolutionApiService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  private headers(token: string): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json', Authorization: `JWT ${token}` });
  }

  async submit(state: OnboardingState, baseUrl: string): Promise<void> {
    const { token } = await this.auth.ensureAuth();
    const payload = state.rows
      .map(row => buildRowPayload(state, row))
      .filter(r => !!r['name']);
    await firstValueFrom(
      this.http.post<any>(`${baseUrl}/metrics/solution-taxonomy/bulk-import/`, payload, { headers: this.headers(token) })
    );
  }
}
